export default __webpack_public_path__ + "static/media/02-shortlist agents.d1c2d899.png";